import React, { useState, createContext, useContext } from 'react';
import PropTypes from 'prop-types';
import { Types } from '@ohif/ui';
const PatientInfoVisibility = Types.PatientInfoVisibility;

const appConfigContext = createContext(null);
const { Provider } = appConfigContext;

export const useAppConfig = () => useContext(appConfigContext);

export function AppConfigProvider({ children, value: initAppConfig }) {
  // epeople: criado defaultConfig para definir nova logo
  const defaultConfig = {
    whiteLabeling: {
      createLogoComponentFn: (React, props) => (
        <img
          src="/assets/logo-epeople.png"
          alt="Logo Epeople"
          width={35}
          {...props}
        />
      ),
    },
    showPatientInfo: PatientInfoVisibility.VISIBLE, //epeople: adicionada configuração para a info do paciente sempre aparecer expandida
    ...initAppConfig,
  };

  const [appConfig, setAppConfig] = useState(defaultConfig);

  return <Provider value={[appConfig, setAppConfig]}>{children}</Provider>;
}

AppConfigProvider.propTypes = {
  children: PropTypes.any,
  value: PropTypes.any,
};

export default AppConfigProvider;
